import MachproHTMLElement from './common/machproHtmlElement';
import { DirectionEnum } from '../customMachTagCompnents/CustomMachScroll';

// https://km.sankuai.com/collabpage/1324032245
// 作为 <scroller> 组件的子组件，并将需要滚动展示的内容添加到 <content> 组件上。
// <content> 组件会自动继承 <scroller> 组件的布局方向（flex-direction）。
export default class Content extends MachproHTMLElement {
  private parentObserver: MutationObserver | null = null;
  private currentParentFlexDirection: string = DirectionEnum.row; // 默认

  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();

    // if (!this.style.display) {
    //   this.style.display = 'flex';
    //   this.style.flexShrink = '0';
    // }

    // 初始同步父级的 flex-direction
    this.syncParentFlexDirection();

    // 开始监听父级样式变化
    this.startParentObserver();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.stopParentObserver();
  }

  private syncParentFlexDirection() {
    try {
      const parentElement = this.parentElement;
      if (!parentElement) {
        return;
      }

      const parentComputedStyle = window.getComputedStyle(parentElement);
      const parentFlexDirection = parentComputedStyle.flexDirection || DirectionEnum.row;

      // 只有当值真正变化时才更新
      if (parentFlexDirection !== this.currentParentFlexDirection) {
        this.currentParentFlexDirection = parentFlexDirection;
        this.style.flexDirection = parentFlexDirection;
      }

      if (parentFlexDirection === DirectionEnum.column) {
        // this.style.height = '100%';
        this.style.flexWrap = 'nowrap';
      }
    } catch (error) {
      console.warn('Failed to sync parent flex-direction:', error);
    }
  }

  private startParentObserver() {
    const parentElement = this.parentElement;
    if (!parentElement) {
      return;
    }

    this.parentObserver = new MutationObserver(() => {
      // 使用 requestAnimationFrame 确保在样式更新后再同步
      requestAnimationFrame(() => {
        this.syncParentFlexDirection();
      });
    });

    this.parentObserver.observe(parentElement, {
      attributes: true,
      attributeFilter: ['style', 'class'],
      subtree: false
    });
  }

  private stopParentObserver() {
    if (this.parentObserver) {
      this.parentObserver.disconnect();
      this.parentObserver = null;
    }
  }
}
